
import global from '@/assets/js/global'
const data = {}
if (global.tenantCode === '130200000000000001' ) {  //唐山人大
  // 数智人大
  data.zhrdList = [
    { label: '机关办公平台', bgColor: '#6CA3F3', url: '', icon: 'icon-book' },
    { label: '人大立法工作管理平台', bgColor: '#AC917C', url: '', icon: 'icon-zhengcefagui2' },
    { label: '预决算公开平台', bgColor: '#AC917C', url: '', icon: 'icon-yijianfankui' },
    { label: '代表履职服务平台', bgColor: '#f56c6c', url: global.serviceUrl, icon: 'icon-tiaochawenjuan' },
    { label: '代表网上联络站', bgColor: '#f56c6c', url: '/liaisonStation', icon: 'icon-shujudaping' }
  ]
  // 专题专栏
  data.ztzlList = [
    { label: '区县人大', url: '/newList?navCode=45&navName=县区人大', imgUrl: global.imageUrl + '/dsxxjy.png' },
    { label: '联动监督', url: '/newList?navCode=33&navName=监督工作', imgUrl: global.imageUrl + '/ldjd.png' },
    { label: '中国共参党网', url: 'https://www.12371.cn/special/20da/', imgUrl: global.imageUrl + '/huazhang.png' }
  ]
  // 互动交流
  data.hdjlList = [
    { label: '电子展馆', bgColor: '#f56c6c', url: 'https://dzzg.tsrd.gov.cn/?scene_id=70879615', icon: 'icon-shujudaping' },
    { label: '意见征集', bgColor: '#AC917C', url: '/newList?navCode=wzdh-yjzj&navName=意见征集', icon: 'icon-shoujianxiang' },
    { label: '网上信访', bgColor: '#6CA3F3', url: '/lettersVisits', icon: 'icon-tiaochawenjuan' },
    { label: '问卷调查', bgColor: '#6CA3F3', url: '/newList?navCode=wzdh-wjdc&navName=问卷调查', icon: 'icon-zhengcefagui2' },
    // { label: '国家法律法规库', bgColor: '#6CA3F3', url: 'https://flk.npc.gov.cn', icon: 'icon-zhengcefagui2' },
    // { label: '地方性法规', bgColor: '#f56c6c', url: '/newList?navCode=39&navName=地方性法规', icon: 'icon-book' }
  ]
  data.picLiList = [

    { label: '人大制度研究会', url: '/jsyjhHome', imgUrl: global.imageUrl + '/rd2_1.png' },
    { label: '法律法规', url: '/newList?navCode=38&navName=法律法规', imgUrl: global.imageUrl + '/rd2_2.png' },
    { label: '地方法规', url: '/newList?navCode=39&navName=地方法规', imgUrl: global.imageUrl + '/rd2_3.png' },
    { label: '规章制度', url: '/newList?navCode=40&navName=规章制度', imgUrl: global.imageUrl + '/rd2_4.png' },
    { label: '理论研究', url: '/newList?navCode=44&navName=理论研究', imgUrl: global.imageUrl + '/rd2_5.png' },
    { label: '工作交流', url: '/newList?navCode=wzdh-xwjpx&navName=工作交流', imgUrl: global.imageUrl + '/rd2_6.png' },
    // { label: '历史沿革', url: '/newList?navCode=20&navName=历史沿革', imgUrl: global.imageUrl + '/rd2_6.png' },


    // { label: '理论研究', url: '/newList?navCode=44&navName=理论研究', imgUrl: global.imageUrl + '/rd2_1.png' },
    // { label: '廉政教育', url: '/newList?navCode=wzdh-lzjy&navName=廉政教育', imgUrl: global.imageUrl + '/rd2_2.png' },
    // { label: '唐山市人大<br />新闻奖评选', url: '/newList?navCode=wzdh-xwjpx&navName=新闻奖评选', imgUrl: global.imageUrl + '/rd2_3.png' },
    // { label: '精神文明建设', url: '/newList?navCode=wzdh-jswmjs&navName=精神文明建设', imgUrl: global.imageUrl + '/rd2_4.png' },
    // { label: '机关党建', url: '/newList?navCode=wzdh-jgdj&navName=机关党建', imgUrl: global.imageUrl + '/rd2_5.png' },
    // { label: '常委会会议', url: '/newList?navCode=23&navName=常委会公报', imgUrl: global.imageUrl + '/rd2_6.png' },
    // { label: '唐山市人大<br />制度理论研究会', url: '/newList?navCode=wzdh-zdllyjh&navName=制度理论研究会', imgUrl: global.imageUrl + '/rd2_7.png' },
    // { label: '国家安全<br />宣传教育', url: '/newList?navCode=wzdh-gjaqxcjy&navName=国家安全宣传教育', imgUrl: global.imageUrl + '/rd2_8.png' }
  ]
  data.footerData = {
    organizer:'唐山市人民代表大会常务委员会',
    address:'唐山市西山道9号',
    zipCode:'063000',
    // phone:'0315-2821856',
    icpText:'冀ICP备05029092号-1',
    icpHttp:'https://beian.miit.gov.cn/',
    partyOrgan:'https://bszs.conac.cn/sitename?method=show&id=077AFDD7AA624E7EE053022819ACDE93',
    publicSecurityText:'冀公网安备13020302000645号',
    publicSecurityHttp:'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13020302000645'
  }
}
export default {
  data
}
